import React from 'react'

import { LearningResource } from './learningResources'
import { LearningResourceCard as Card } from '../styles'

interface LearningResourceCardProps {
  resource: LearningResource
  unavailable?: boolean
  onOpen: (resource: LearningResource) => void
}

const LearningResourceCard = ({
  resource,
  unavailable = false,
  onOpen,
}: LearningResourceCardProps) => (
  <Card
    type="button"
    onClick={() => onOpen(resource)}
    disabled={unavailable}
    aria-label={resource.title}
  >
    <div className="resource-image">
      <img src={resource.image} alt="" aria-hidden="true" />
      <span className="resource-title">{resource.title}</span>
    </div>
    <p className="resource-description">
      {unavailable
        ? resource.unavailableDescription || resource.description
        : resource.description}
    </p>
  </Card>
)

export default LearningResourceCard
